import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import PeopleIcon from '@mui/icons-material/People';
import WorkIcon from '@mui/icons-material/Work';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { Container, Header, HeaderLeft, BackButton, Title, Content, MainSection } from '../common/styles';
import { StyledCard, StyledIconButton } from '../LandingPage/styles';

const cards = [
  {
    id: 'import-employees',
    title: 'Import Individuals',
    description: 'Import individual data from external sources',
    icon: <PeopleIcon />,
    path: '/data-import/employees',
    customIconStyle: {
      backgroundColor: '#2196F3',
    }
  },
  {
    id: 'import-projects',
    title: 'Import Projects',
    description: 'Import project data from external sources',
    icon: <WorkIcon />,
    path: '/data-import/projects',
    customIconStyle: { 
      backgroundColor: '#4CAF50',
    }
  },
  {
    id: 'attach-employees-to-projects',
    title: 'Attach Individuals to Projects',
    description: 'Import individual-to-project assignments with roles and engagement details',
    icon: <GroupWorkIcon />,
    path: '/data-import/employee-to-project',
    customIconStyle: {
      backgroundColor: '#FF9800',
    }
  }
];

const DataImport = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={() => navigate('/')}>
            <FaArrowLeft /> Back to Dashboard
          </BackButton>
          <Title>Data Import</Title>
        </HeaderLeft>
      </Header>

      <Content>
        <MainSection>
          <Typography variant="body1" paragraph>
            Select what type of data you want to import
          </Typography>
          
          <Grid container spacing={3}>
            {cards.map((card) => (
              <Grid item xs={12} md={6} key={card.id}>
                <StyledCard onClick={() => navigate(card.path)}>
                  <StyledIconButton
                    sx={{ 
                      ...card.customIconStyle,
                      '&:hover': {
                        ...card.customIconStyle
                      }
                    }}
                  >
                    {card.icon}
                  </StyledIconButton>
                  <Typography variant="h6" align="center">{card.title}</Typography>
                  <Typography variant="body2" color="textSecondary" align="center">
                    {card.description}
                  </Typography>
                </StyledCard>
              </Grid>
            ))}
          </Grid>
        </MainSection>
      </Content>
    </Container>
  );
};

export default DataImport;